import React, { useEffect } from "react";
import { Box } from "@origin-digital/ods-core";
import AppRoutes from "./Routes/AppRoutes";
import { routeConfig } from "./Routes/RouteConfig";
import { setTokenRetrievalMethod } from "./api/apiService";
import { useAuth0 } from "./hooks/useAuth";
import { Header } from "./components/Header";
import { useLoginUserEffect } from "./hooks/useLoginUserEffect";
import { Footer } from "./components/Footer";
import { ExposeCssSelectorSuggestion } from "./components/WindowRuntime";

const Root = () => {
  const { getAccessTokenSilently } = useAuth0();
  useLoginUserEffect();
  useEffect(() => {
    // Set the token retrieval method for the Axios instance
    setTokenRetrievalMethod(async () => {
      try {
        const token = await getAccessTokenSilently();
        return token;
      } catch (error) {
        console.error("Error getting access token", error);
        return null;
      }
    });
  }, [getAccessTokenSilently]);

  return (
    <Box
      style={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Header />
        <Box
          display="flex"
          justifyContent="center"
          style={{
            marginTop: "64px",
          }}
        >
          <AppRoutes routes={routeConfig} />
        </Box>
      </Box>
      <Box>
        <Footer />
      </Box>
      <ExposeCssSelectorSuggestion />
    </Box>
  );
};

export default Root;
